import { makeStyles, useMediaQuery } from '@material-ui/core'
import React from 'react'

function Footer() {

    const mobile = useMediaQuery('(max-width: 500px)')
    const styles = useStyles({ mobile });

    return (
        <div className={styles.footerContainer}>
            Designed and Developed by Affan Ahmad.
        </div>
    )
}

export default Footer

const useStyles = makeStyles(({
    footerContainer: {
        marginTop: '30px',
        backgroundColor: '#33658A',
        color: '#F4F4F8',
        padding: '15px',
        fontSize: '0.9rem',
        textAlign: 'center',
        '&:hover': {
            color: '#E4FDE1'
        }
    }
}))
